import React from 'react';

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import YearMonthField from '../Atoms/YearMonthField';
import SingleNextButton from '../Atoms/SingleNextButton';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import { getApp, setApp } from '../../index';
import { zipRegex, currencyRegex } from '../../Utils/ValidationPatterns';
import { usStates, phoneTypes, caOwnershipStatuses } from '../../Utils/SelectOptions';

class StepCoApplicantContact extends React.Component {

    constructor(props) {
        super(props);
        this.state = { coAppSameAddress: '' };
    }

    componentDidMount() {

        var existingSameAddressValue = getApp('sameAddress');

        if(existingSameAddressValue !== "") {

            this.setState({ coAppSameAddress: existingSameAddressValue });
            
            var sameID;

            if(existingSameAddressValue === "yes") {
                sameID = "coAppYesAddress";
            }
            if(existingSameAddressValue === "no") {
                sameID = "coAppNoAddress";
            }

            document.getElementById(sameID).checked = true;

        }
    
    }

    coAppAddress(event) {
        var newState = event.target.value;
        this.setState({ coAppSameAddress: newState });
        setApp('sameAddress', newState);
        if(newState === 'yes'){
            setApp('caAddress', getApp('address'));
            setApp('caAddress2', getApp('address2'));
            setApp('caState', getApp('state'));
            setApp('caCity', getApp('city'));
            setApp('caZip', getApp('zipcode'));
            setApp('caMonthlyPayment', getApp('monthlyPayment'));
        }else if(newState === 'no') {
            setApp('caMonthlyPayment', getApp('caMonthlyPayment'));
            if(getApp('caAddress') === getApp('address')){
                setApp('caAddress', '');
            }
            if(getApp('caAddress2') === getApp('address2')){
                setApp('caAddress2', '');
            }
            if(getApp('caState') === getApp('state')){
                setApp('caState', '');
            }
            if(getApp('caCity') === getApp('city')){
                setApp('caCity', '');
            }
            if(getApp('caZip') === getApp('zipcode')){
                setApp('caZip', '');
            }
        }
    }

    render() {
        var rFirstName = getApp('ca_fname');
        var caFirstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);        
        return (
            <StepShell stepID="StepCoApplicantContact"
                friendlyText={`Does ${caFirstName} have the same address as you?`}
                requestText=""
                progress="71.25%"
                backLink="/loan-application/co-applicant-info"
                progressLabel="Co-Applicant Contact"
            >
                <Form nextLink="/loan-application/co-applicant-work">
                    <div className="loanApp-radio-buttons hug" onChange={this.coAppAddress.bind(this)}>
                        <div className="loanApp-form-row">              
                            <div className="loanApp-radio">                             
                                <input type="radio" name="sameAddress" value="yes" className="pull-left loanApp-form-control" id="coAppYesAddress" />
                                <label htmlFor="coAppYes">YES</label>
                                 <InvalidFeedback feedback="invalid" />
                            </div>
                            <div className="loanApp-radio">                             
                                <input type="radio" name="sameAddress" value="no" className="pull-left loanApp-form-control" id="coAppNoAddress" />
                                <label htmlFor="coAppNo">NO</label>
                                 <InvalidFeedback feedback="invalid" />
                            </div>
                        </div>
                    </div>  
                    {this.state.coAppSameAddress === "no" ? <DifferentAddress /> : null}
                    {this.state.coAppSameAddress === "yes" ? <SameAddress /> : null}
                </Form>
            </StepShell>
        )
    }
}

class CoAppMailingAddress extends React.Component {
    render() {
        var rFirstName = getApp('ca_fname');
        var caFirstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        return (
            <div className="coAppMailing-address">
                <TextField name="coAppMailingAddress" label={`${caFirstName}'s Mailing Address`} required={true} />
                <TextField name="coAppMailingAddress2" label={`${caFirstName}'s Mailing Address 2`} required={false} />
                <TextField name="coAppMailingCity" label={`${caFirstName}'s Mailing City`} required={true}/>
                <SelectField options={usStates} required={true} name="coAppMailingState" placeholder="State" labelType="bold" label={`Select ${caFirstName}'s State`}
                            />
                <NumberField name="coAppMailingZipcode" pattern={zipRegex} format="#####" label={`${caFirstName}'s Mailing Zipcode`} required={true}/>
            </div>
        )
    }
}

class DifferentAddress extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            mailingAddress: false,
            showMonthlyPayment: false
        }
    }

    toggleMailingAddress(event) {
        var flipMailing = this.state.mailingAddress;

        this.setState({
            mailingAddress: !flipMailing
        });

        setApp('coAppMailingCheck', !flipMailing);

        if(!flipMailing === true) {
            if(getApp('saveCoAppMailingAddress') !== "") { setApp('coAppMailingAddress', getApp('saveCoAppMailingAddress')); }
            if(getApp('saveCoAppMailingAddress2') !== "") { setApp('coAppMailingAddress2', getApp('saveCoAppMailingAddress2')); }
            if(getApp('saveCoAppMailingCity') !== "") { setApp('coAppMailingCity', getApp('saveCoAppMailingCity')); }
            if(getApp('saveCoAppMailingState') !== "") { setApp('coAppMailingState', getApp('saveCoAppMailingState')); }
            if(getApp('saveCoAppMailingZipcode') !== "") { setApp('coAppMailingZipcode', getApp('saveCoAppMailingZipcode')); }            
        }else {
            setApp('saveCoAppMailingAddress', getApp('coAppMailingAddress'));
            setApp('saveCoAppMailingAddress2', getApp('coAppMailingAddress2'));
            setApp('saveCoAppMailingCity', getApp('coAppMailingCity'));
            setApp('saveCoAppMailingState', getApp('coAppMailingState'));
            setApp('saveCoAppMailingZipcode', getApp('coAppMailingZipcode'));
            setTimeout(function(){
                setApp('coAppMailingAddress', '');
                setApp('coAppMailingAddress2', '');
                setApp('coAppMailingCity', '');
                setApp('coAppMailingState', '');
                setApp('coAppMailingZipcode', '');                
            }, 100);
        }
    }

    checkLivingSituation(event) {
        var glLivingSit = getApp('caOwnershipStatus');
        if(glLivingSit === "Rents" || glLivingSit === "Owns") {
            this.setState({"showMonthlyPayment":true});
        }else{
            this.setState({"showMonthlyPayment":false});
        }
    }

    render() {
        var rFirstName = getApp('ca_fname');
        var caFirstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        let mailing;
        let mailingClass;
        // let mPayment;

        if(this.state.mailingAddress) {
            mailingClass = "remove";
            mailing = (
                <CoAppMailingAddress />
            );
        }else if(getApp('coAppMailingCheck') === true) {
            mailingClass = "remove";
            mailing = (
                <CoAppMailingAddress />
            );
        }else {
            mailingClass = "add";
            mailing = "";
        }

        var mPaymentRequired = ( <NumberField name="caMonthlyPayment" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Monthly Payment`} required={true}/> );
        var mPaymentOptional = ( <NumberField name="caMonthlyPayment" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Monthly Payment (optional)`} required={false}/> );

        return (
            <fieldset>
                <div className="step-request-text">We also need to know about where {caFirstName} lives.</div>    
                <TextField name="caAddress" label={`${caFirstName}'s Address`} required={true} />
                <TextField name="caAddress2" label={`${caFirstName}'s Address 2`} />
                <TextField name="caCity" label={`${caFirstName}'s City`} required={true}/>
                <SelectField options={usStates} required={true} name="caState" placeholder={`${caFirstName}'s State`} labelType="bold" label="Select Co-Applicant's State"
                            />
                <NumberField name="caZip" pattern={zipRegex} format="#####" label={`${caFirstName}'s Zipcode`} required={true}/>
                <div className="loanApp-form-row">
                    <div className="col col-8">
                        <NumberField name="caPhone" label={`${caFirstName}'s Primary Telephone`} required={true} type="tel" minLength="14" format="(###) ###-####" pattern="^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$"/>
                    </div>
                    <div className="col col-4">
                        <SelectField options={phoneTypes} required={true} name="caPhoneType" placeholder="Phone Type" labelType="hidden"
                            />  
                    </div>
                </div> 
                <label htmlFor="caOwnershipStatus" className="bold-label">{caFirstName}'s Living Situation:</label>
                <div onChange={this.checkLivingSituation.bind(this)} >
                    <SelectField options={caOwnershipStatuses} required={true} name="caOwnershipStatus" placeholder="Select One" label="ownership status" labelType="hidden"
                    />
                </div>
                {this.state.showMonthlyPayment ? mPaymentRequired : mPaymentOptional }
                <span className="period-at-residence-text hug dropdown-text">How long has {caFirstName} lived at their current residence?</span>
                <YearMonthField yearsName="caYears" yearsLabel="Years" monthsName="caMonths" monthsLabel="Months" />
                <div className="loanApp-form-row add-mailing-address">
                    <div className="step-request-text">
                        If {caFirstName} has a different mailing address than their current residence (such as a P.O. Box), <span className={mailingClass} onClick={this.toggleMailingAddress.bind(this)} > a Mailing Address</span>
                    </div>
                    {mailing}
                </div>
                <SingleNextButton nextBtnTxt="next" />
            </fieldset>
        )
    }
}

class SameAddress extends React.Component {
    render() {
        var rFirstName = getApp('ca_fname');
        var caFirstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        return (
            <fieldset>
                <div className="step-request-text">We just need to know {caFirstName}’s phone number then.</div>
                <div className="loanApp-form-row">
                    <div className="col col-8">
                        <NumberField name="caPhone" label={`${caFirstName}'s Primary Telephone`} required={true} type="tel" minLength="14" format="(###) ###-####" pattern="^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$"/>
                    </div>
                    <div className="col col-4">
                        <SelectField options={phoneTypes} required={true} name="caPhoneType" placeholder="Phone Type" labelType="hidden"
                                />
                    </div>
                </div>
                <SingleNextButton nextBtnTxt="next" />          
            </fieldset>
        )
    }
}

export default StepCoApplicantContact;
